import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import styles from './styles.module.scss';
import { useGetMailPlaceholders } from 'hook/useMailTemplate';

/* eslint-disable */
const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
    ['link'],
  ],
};
/* eslint-enable */

// Editor nội dung mail + danh sách placeholder bấm để chèn vào vị trí con trỏ
const MailEditor = ({ value, onChange, error, disabled }) => {
  const { t } = useTranslation();
  const quillRef = useRef(null);
  const { data: listPlaceholder } = useGetMailPlaceholders();

  const insertPlaceholder = (placeholder) => {
    const editor = quillRef.current?.getEditor();
    if (!editor || disabled) return;
    const range = editor.getSelection(true);
    editor.insertText(range.index, placeholder, 'user');
    editor.setSelection(range.index + placeholder.length, 0);
  };

  return (
    <div className={styles.mailEditor}>
      <div className={styles.placeholderBox}>
        <span className={styles.placeholderLabel}>{t('managerMailTemplate.insertPlaceholder')}</span>
        {listPlaceholder.map((placeholder) => (
          <button
            type="button"
            key={placeholder}
            className={styles.placeholderChip}
            onClick={() => insertPlaceholder(placeholder)}
            title={t(`managerMailTemplate.placeholder.${placeholder.replace(/[{}]/g, '')}`)}
          >
            {placeholder}
          </button>
        ))}
      </div>
      <ReactQuill
        ref={quillRef}
        value={value || ''}
        modules={modules}
        onChange={(content, delta, source, editor) => onChange(editor.getText().trim() ? content : '')}
        readOnly={disabled}
        className={styles.editor}
      />
      <p className={styles.hint}>{t('managerMailTemplate.editorHint')}</p>
      {error && <p className="error">{error}</p>}
    </div>
  );
};

export default MailEditor;
